import script from "./telearn.vue?vue&type=script&setup=true&lang=js"
export * from "./telearn.vue?vue&type=script&setup=true&lang=js"

import "./telearn.vue?vue&type=style&index=0&id=6dba96f6&scoped=true&lang=css"

import exportComponent from "F:\\work\\FFSTAR3\\VUESP\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6dba96f6"]])

export default __exports__